import React from 'react';

import { Select } from '@gogame/components';
import { withFormField } from '@gogame/form';

const EMPTY_OPTIONS = [];

export const MultiChangeSelect = withFormField({})(
  ({
    area,
    value,
    name,
    label,
    required,
    disabled,
    error,
    onMultiChange,
    helper,
    onBlur,
    onFocus,
  }) => {
    return (
      <Select
        name={name}
        value={value}
        onChange={onMultiChange}
        loading={area.loading}
        options={area.data || EMPTY_OPTIONS}
        label={label}
        required={required}
        error={error}
        disabled={disabled}
        helper={helper}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    );
  }
);
